var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "53a6ddd1f8b8e6ad36bf411eb77c37b2a158f32d"
};